$(document).ready(function() {
  $(".module-style__teaser-manager-references .category-element .module-content-block").each(function() {
    $(this).children(".headline-wrapper, text-wrapper, p").wrapAll($("<div/>", { "class": "text-on-image" }));
  });

  $('.Community_SocialMedia_Feed a').each(function(i, elem) {
    var $elem = $(elem), text = $elem.text();
    if(text.length > 0 && text.charAt(0) == '#') {
      $(this).remove();
    }
  });
});

$(document).ready(function() {
  //parallax scroll
  $(window).on("load scroll", function() {
    var parallaxElement = $(".content .module-wrapper:not(.Special_ChangingContents) .headline-wrapper .headline1"),
      parallaxQuantity = parallaxElement.length;
    window.requestAnimationFrame(function() {
      for (var i = 0; i < parallaxQuantity; i++) {
        var currentElement = parallaxElement.eq(i),
          windowTop = $(window).scrollTop(),
          elementTop = currentElement.offset().top,
          elementHeight = currentElement.height(),
          viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
          scrolled = windowTop - elementTop + viewPortHeight;
        currentElement.css({
          transform: "translate3d(0," + scrolled * -0.04 + "px, 0)"
        });
      }
    });
  });
});

$(document).ready(function() {
  //parallax scroll
  $(window).on("load scroll", function() {
    var parallaxElement = $(".content .module-wrapper:not(.Special_ChangingContents) .headline-wrapper .headline2"),
      parallaxQuantity = parallaxElement.length;
    window.requestAnimationFrame(function() {
      for (var i = 0; i < parallaxQuantity; i++) {
        var currentElement = parallaxElement.eq(i),
          windowTop = $(window).scrollTop(),
          elementTop = currentElement.offset().top,
          elementHeight = currentElement.height(),
          viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
          scrolled = windowTop - elementTop + viewPortHeight;
        currentElement.css({
          transform: "translate3d(0," + scrolled * -0.02 + "px, 0)"
        });
      }
    });
  });
});

$(document).ready(function() {
  //parallax scroll
  $(window).on("load scroll", function() {
    var parallaxElement = $(".content .module-wrapper:not(.Special_ChangingContents) .headline-wrapper .headline3"),
      parallaxQuantity = parallaxElement.length;
    window.requestAnimationFrame(function() {
      for (var i = 0; i < parallaxQuantity; i++) {
        var currentElement = parallaxElement.eq(i),
          windowTop = $(window).scrollTop(),
          elementTop = currentElement.offset().top,
          elementHeight = currentElement.height(),
          viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
          scrolled = windowTop - elementTop + viewPortHeight;
        currentElement.css({
          transform: "translate3d(0," + scrolled * -0.04 + "px, 0)"
        });
      }
    });
  });
});

$(document).ready(function() {
  //parallax scroll
  $(window).on("load scroll", function() {
    var parallaxElement = $(".content .module-wrapper:not(.Special_ChangingContents) .thumbnail"),
      parallaxQuantity = parallaxElement.length;
    window.requestAnimationFrame(function() {
      for (var i = 0; i < parallaxQuantity; i++) {
        var currentElement = parallaxElement.eq(i),
          windowTop = $(window).scrollTop(),
          elementTop = currentElement.offset().top,
          elementHeight = currentElement.height(),
          viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
          scrolled = windowTop - elementTop + viewPortHeight;
        currentElement.css({
          transform: "translate3d(0," + scrolled * -0.02 + "px, 0)"
        });
      }
    });
  });
});

$(document).ready(function() {
  //parallax scroll
  $(window).on("load scroll", function() {
    var parallaxElement = $(".module-style__key-facts-references.Text_Link_TextImageLeft .module-content-block>.row>[class*=col-]:last-child, .module-style__key-facts-references.Text_Link_TextImageRight .module-content-block>.row>[class*=col-]:first-child, .module-style__key-facts-references.key-facts-references-right.Text_Link_TextImageTwo>[class*=col-]>.row>[class*=col-]:last-child, .module-style__key-facts-references.key-facts-references-left.Text_Link_TextImageTwo>[class*=col-]>.row>[class*=col-]:first-child"),
      parallaxQuantity = parallaxElement.length;
    window.requestAnimationFrame(function() {
      for (var i = 0; i < parallaxQuantity; i++) {
        var currentElement = parallaxElement.eq(i),
          windowTop = $(window).scrollTop(),
          elementTop = currentElement.offset().top,
          elementHeight = currentElement.height(),
          viewPortHeight = window.innerHeight * 0.8 - elementHeight * 0.5,
          scrolled = windowTop - elementTop + viewPortHeight;
        currentElement.css({
          transform: "translate3d(0," + scrolled * -0.1 + "px, 0)"
        });
      }
    });
  });
});

$(document).ready(sliderCaptionMargin);
$(window).on('resize',sliderCaptionMargin);

function sliderCaptionMargin() {
  var fixedElements = $('.header');
  $('.slider.slider_small .carousel-caption').css({'margin-top': fixedElements.outerHeight(true) + fixedElements.prev().outerHeight(true) + 60 + 'px'});
}